module.exports = __webpack_public_path__ + "img/topicbanner.ffcc5221.png";